import React, { useState, useEffect } from "react";
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from "@material-ui/core/styles";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { Create, Add, LocalShippingRounded } from "@material-ui/icons";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGetAll } from "services/WService.js";

import ModalVehicle from "./ModalVehicle";
import { Toasty, useToasty } from "hooks/Toasty";
import ButtonDelete from "hooks/ButtonDelete";
import { useModal } from "hooks/useModal";
import { WithApp } from "contexts/appContext";

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
});

const columns = [
  { Header: "#", accessor: "num", excelEnabled: false, width: 130 },
  { Header: "Código", accessor: "code", width: 100 },
  { Header: "Nombre vehículo", accessor: "name", width: 350 },
  { Header: "Código", accessor: "CardCode", width: 130 },
  { Header: "Transportistas", accessor: "CardName", width: 350 },
  { Header: "Tarjeta Circulación", accessor: "card_circulation", width: 180 },
  { Header: "Jefe reparto", accessor: "manager_name", width: 350 },
  { Header: "Año", accessor: "year", width: 90 },
  { Header: "Color", accessor: "color", width: 115 },
  { Header: "Marca", accessor: "brand", width: 120 },
  { Header: "Modelo", accessor: "model", width: 120 },
  { Header: "peso", accessor: "weight", width: 120 },
  { Header: "Serie", accessor: "serial", width: 160 },
  { Header: "", accessor: "actions", width: 0 }
];

export default WithApp(function Vehicle(props) {
  const classes = useStyles();
  const totalTableWidth = columns.reduce((sum, col) => sum + (col.width || 0), 0);

  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();

  const [vehicles, setVehicles] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function loadVehicles() {
    setDataLoading(true);
    let response = await wsGetAll("prog/public-vehicle");
    setDataLoading(false);
    if (response.success) setVehicles(response.data);
  }

  useEffect(() => {
    loadVehicles();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />

      <ModalVehicle
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadVehicles}
      />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.PROG_VEHICLES_STORE}
              component={
                <CardIcon color="primary">
                  <LocalShippingRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                color={props.themeContext.buttonColorSuccess}
                pointer="true"
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Vehículos Públicos {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Vehículos"
              defaultWidth={totalTableWidth}
              columns={columns}
              data={vehicles.map((vehicle, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard
                        permission={ConstantPermissions.PROG_VEHICLES_UPDATE}
                      >
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          className="like"
                          onClick={() => setOpen(vehicle)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.PROG_VEHICLES_DELETED}
                      >
                        <ButtonDelete
                          entity="prog/vehicle"
                          id={vehicle.id}
                          reload={loadVehicles}
                        />
                      </AllowedGuard>
                    </div>
                  ),
                  code: vehicle.code,
                  name: vehicle.name,
                  CardCode: vehicle.CardCode,
                  CardName: vehicle.CardName,
                  manager_name: vehicle.manager_name,
                  card_circulation: vehicle.card_circulation,
                  year: vehicle.year,
                  color: vehicle.color,
                  brand: vehicle.brand,
                  model: vehicle.model,
                  weight: vehicle.weight,
                  serial: vehicle.serial,
                  actions: ""
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
